import { Common } from './common';
import {
  EntityId,
  Fingerprint,
  RuleGroup,
  SearchId,
  OutputKind,
} from './models/fingerprint/conjecture';
import { Event } from './models/fingerprint/event';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async construct(entityId: EntityId): Promise<Fingerprint> {
    const url = this.common.constructPath('/fingerprint', entityId);
    return this.common.getJSON(url);
  }

  async findEvent(id: string): Promise<Event> {
    const url = this.common.constructPath(`/fingerprint/events/${id}`);
    return this.common.getJSON(url);
  }

  async test(entityId: SearchId, scenarioId: string): Promise<RuleGroup[]> {
    const url = this.common.constructPath('/fingerprint/test');
    return this.common.postJSON(url, { ...entityId, scenarioId });
  }

  async query(options: {
    encounterIds?: string[];
    ehrInformationIds?: string[];
    patientOrderIds?: string[];
    outputs: OutputKind[];
    queryOnly?: boolean;
  }) {
    const url = this.common.constructPath('/fingerprint');
    return this.common.postJSON(url, options);
  }
}
